import React from "react";
import { Link } from "react-router-dom";
import { Layers, Info, BookOpen } from "lucide-react";

// Shown after a graded standalone run: card earned, or why it wasn't, plus the pack debrief.
export const CallCardNotice = ({ result }) => {
  if (!result) return null;
  return (
    <>
      {result.call_card && (
        <div className="tc-card p-4 border-tc-xp/30 bg-tc-xp/5 text-left" data-testid="call-card-minted">
          <div className="font-semibold flex items-center gap-1.5"><Layers className="w-4 h-4 text-tc-xp" /> Call Card added to My Calls</div>
          <p className="text-xs text-tc-sub mt-1">A private record of your call and your reasoning. <Link to="/my-calls" className="text-tc-coach underline" data-testid="call-card-open-link">Open My Calls</Link></p>
        </div>
      )}
      {result.call_card_missing_why && (
        <div className="tc-card p-4 text-left" data-testid="call-card-missing-why">
          <div className="font-semibold flex items-center gap-1.5"><Info className="w-4 h-4 text-tc-coach" /> Top grade, but no Call Card</div>
          <p className="text-xs text-tc-sub mt-1">A card needs your "why" written at the moment of the call (10+ characters). Next time, fill in the reasoning box before you lock your call or PASS.</p>
        </div>
      )}
      {result.pack_debrief && (
        <div className="tc-card p-4 text-left space-y-1.5" data-testid="pack-debrief">
          <div className="text-[10px] font-mono uppercase tracking-widest text-tc-xp flex items-center gap-1.5"><BookOpen className="w-3.5 h-3.5" /> {result.pack_debrief.pack} · {result.pack_debrief.date_window}</div>
          <div className="font-semibold">{result.pack_debrief.lesson}</div>
          <p className="text-sm text-tc-sub">{result.pack_debrief.text}</p>
          <p className="text-[11px] text-tc-muted">{result.pack_debrief.honesty}</p>
        </div>
      )}
    </>
  );
};
